// extracted by mini-css-extract-plugin
export default {"votePerson":"index_votePerson_8QVet","head":"index_head_OnMX5","face":"index_face_zAKut","username":"index_username_-QX4B","voteValue":"index_voteValue_XbF95"};